{
  "Accessibility Menu": "Izbornik Pristupačnosti",
  "Reset settings": "Resetiraj postavke",
  "Close": "Zatvori",
  "Content Adjustments": "Prilagodbe Sadržaja",
  "Adjust Font Size": "Prilagodi Veličinu Fonta",
  "Highlight Title": "Istakni Naslove",
  "Highlight Links": "Istakni Poveznice",
  "Readable Font": "Čitljiv Font",
  "Color Adjustments": "Prilagodbe Boja",
  "Dark Contrast": "Tamni Kontrast",
  "Light Contrast": "Svijetli Kontrast",
  "High Contrast": "Visoki Kontrast",
  "High Saturation": "Visoka Zasićenost",
  "Low Saturation": "Niska Zasićenost",
  "Monochrome": "Jednobojno",
  "Tools": "Alati",
  "Reading Guide": "Vodič Za Čitanje",
  "Stop Animations": "Zaustavi Animacije",
  "Big Cursor": "Veliki Kursor",
  "Increase Font Size": "Povećaj Veličinu Fonta",
  "Decrease Font Size": "Smanji Veličinu Fonta",
  "Letter Spacing": "Razmak Između Slova",
  "Line Height": "Visina Linije",
  "Font Weight": "Debljina Fonta",
  "Dyslexia Font": "Font Za Disleksiju",
  "Language": "Jezik",
  "Open Accessibility Menu": "Otvori Izbornik Pristupačnosti"
}
